var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.title || _vm.t)?_c('div',[_c('div',{staticClass:"title",style:({ color: _vm.color })},[_vm._v(_vm._s(_vm.title || _vm.t))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }